import React, { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ApiService } from "../../services/api";
import { useAuth } from "../../contexts/AuthContext";

export default function PaymentResultPage({ success }: { success: boolean }) {
  const navigate = useNavigate();
  const { refreshUserData } = useAuth();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const [status, setStatus] = useState(success ? "PENDING" : "FAILED");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!success || !orderId) return;
    let active = true;
    let attempts = 0;
    const poll = async () => {
      try {
        const order = await ApiService.getPaymentOrder(orderId);
        if (!active) return;
        setStatus(order.status);
        if (order.status === "PAID") {
          await refreshUserData();
          return;
        }
        if (["FAILED", "CANCELLED", "REFUNDED"].includes(order.status)) {
          setMessage(order.errorMessage || "Ödeme tamamlanamadı.");
          return;
        }
        attempts += 1;
        if (attempts < 20) window.setTimeout(poll, 1500);
        else setMessage("Ödeme doğrulaması devam ediyor. Birkaç dakika sonra tekrar kontrol edin.");
      } catch (error: any) {
        setMessage(error?.message || "Ödeme durumu alınamadı.");
      }
    };
    void poll();
    return () => { active = false; };
  }, [orderId, refreshUserData, success]);

  const paid = status === "PAID";
  const returnTo = sessionStorage.getItem("paymentReturnTo") || "/dashboard";

  return (
    <div className="flex h-full items-center justify-center bg-slate-100 p-6">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        {paid ? <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" /> : status === "PENDING" ? <Loader2 className="mx-auto h-14 w-14 animate-spin text-violet-600" /> : <XCircle className="mx-auto h-14 w-14 text-red-500" />}
        <h1 className="mt-4 text-2xl font-bold text-slate-900">{paid ? "Ödeme tamamlandı" : status === "PENDING" ? "Ödeme doğrulanıyor" : "Ödeme tamamlanamadı"}</h1>
        <p className="mt-2 text-sm text-slate-600">{paid ? "Ücretli modüller hesabınız için açıldı." : message || "Sağlayıcı sonucu güvenli biçimde doğrulanıyor."}</p>
        <button onClick={() => navigate(paid ? returnTo : "/payment")} className="mt-6 rounded-xl bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white">
          {paid ? "Modüle Git" : "Ödeme Ekranına Dön"}
        </button>
      </div>
    </div>
  );
}
